/**
 * Pins dos exemplares no mapa: gota branca com o desenho do tipo (arvore, palmeira, muda).
 * O contorno e o desenho levam a cor do risco da ultima vistoria validada, entao a legenda de
 * risco continua valendo; o tipo e lido pelo desenho, nao pela cor.
 */

const PIN_PATH = "M16 39C10 31 3 25 3 15.5a13 13 0 1 1 26 0C29 25 22 31 16 39z";

function glyph(tipo: string, color: string): string {
  switch (tipo) {
    case "ARVORE":
      return `<g fill="${color}">
        <circle cx="16" cy="11.5" r="4.6"/><circle cx="11.6" cy="15" r="4.2"/>
        <circle cx="20.4" cy="15" r="4.2"/><circle cx="16" cy="16.5" r="4.2"/>
        <path d="M14.6 17.5h2.8l.5 6.2h-3.8z"/></g>
        <path d="M13.6 15.6l2.4 2.4 2.4-2.4" stroke="#fff" stroke-width="1.3" fill="none" stroke-linecap="round"/>`;
    case "PALMEIRA":
      return `<g fill="${color}">
        <path d="M15.2 13.5h1.6l1.2 10.3h-4z"/>
        <path d="M16 13.2c-1.5-2.4-4.6-3.4-7.6-2.5 2.6.3 4.8 1.4 7.6 2.5z"/>
        <path d="M16 13.2c1.5-2.4 4.6-3.4 7.6-2.5-2.6.3-4.8 1.4-7.6 2.5z"/>
        <path d="M16 13.4c-2.6-.4-5.6 1-7 3.8 2.2-1.6 4.4-2.6 7-3.8z"/>
        <path d="M16 13.4c2.6-.4 5.6 1 7 3.8-2.2-1.6-4.4-2.6-7-3.8z"/>
        <path d="M16 13c-.9-1.9-.5-3.8.3-5.3.6 1.6.6 3.5-.3 5.3z"/></g>
        <path d="M14.8 17.6h2.6M14.6 20.4h3" stroke="#fff" stroke-width="0.9"/>`;
    case "MUDA":
      return `<g fill="${color}">
        <path d="M16 21.5c-.2-2.6-.8-4.3-2-5.6-1.4-1.5-3.4-2-5-1.8.2 2.2 1.4 4 3.3 4.7 1.2.5 2.4.6 3.7 2.7z"/>
        <path d="M16.2 21.5c.1-3.4.8-6 2.6-7.8 1.5-1.5 3.6-2.2 5.2-2.1-.1 2.6-1.4 4.7-3.6 5.8-1.7.8-3.2 1.5-4.2 4.1z"/>
        <path d="M10.6 24c1.2-1.6 3.2-2.5 5.4-2.5s4.2.9 5.4 2.5z"/></g>`;
    default:
      return `<text x="16" y="20.5" text-anchor="middle" font-size="11" font-weight="700"
        font-family="Arial,sans-serif" fill="${color}">?</text>`;
  }
}

/** SVG do pin (32 x 40). `selected` engrossa o contorno em azul. */
export function treePinSvg(tipo: string, color: string, selected = false, width = 26): string {
  const stroke = selected ? "#3b82f6" : color;
  const height = Math.round((width * 40) / 32);
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 32 40"
    style="display:block;filter:drop-shadow(0 1px 2px rgba(0,0,0,.35))">
    <path d="${PIN_PATH}" fill="#fff" stroke="${stroke}" stroke-width="${selected ? 3.2 : 2.4}"/>
    ${glyph(tipo, color)}</svg>`;
}

export function pinWidth(tipo: string): number {
  return tipo === "MUDA" ? 22 : 26;
}
